
import { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { useToast } from "@/hooks/use-toast";
import { supabase } from "@/integrations/supabase/client";
import PageSEO from "@/components/seo/PageSEO";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const { toast } = useToast();

  const from = location.state?.from?.pathname || "/app";

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);

    const { error } = await supabase.auth.signInWithPassword({
      email,
      password,
    });

    if (error) {
      toast({
        title: "Erro ao fazer login.",
        description: error.message,
        variant: "destructive",
      });
    } else {
      toast({
        title: "Login efetuado com sucesso!",
        description: "Redirecionando...",
      });
      navigate(from, { replace: true });
    }

    setLoading(false);
  };

  const breadcrumbs = [
    {
      position: 1,
      name: "Início",
      item: "https://metrocalma.org"
    },
    {
      position: 2,
      name: "Login",
      item: "https://metrocalma.org/login"
    }
  ];

  return (
    <>
      <PageSEO 
        title="Login - MetroCalma | Acesse sua conta de bem-estar mental"
        description="Faça login na MetroCalma para acessar suas ferramentas personalizadas de bem-estar mental, testes de personalidade e acompanhamento emocional."
        canonicalUrl="https://metrocalma.org/login"
        keywords="login MetroCalma, acesso conta, bem-estar mental, testes personalidade"
        pageName="Login"
        breadcrumbs={breadcrumbs}
      />
      
      <div className="container relative h-[calc(100vh-0px)] flex items-center justify-center">
        <Card className="w-[350px]">
          <CardHeader className="space-y-1">
            <CardTitle className="text-2xl text-center">Entre na sua conta</CardTitle>
            <CardDescription className="text-center">
              Insira seu email e senha abaixo para acessar sua conta
            </CardDescription>
          </CardHeader>
          <CardContent className="grid gap-4">
            <div className="grid gap-2">
              <Label htmlFor="email">Email</Label>
              <Input
                id="email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="seu-email@exemplo.com"
              />
            </div>
            <div className="grid gap-2">
              <Label htmlFor="password">Senha</Label>
              <Input
                id="password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </div>
          </CardContent>
          <CardFooter className="flex flex-col items-center gap-2">
            <Button disabled={loading} className="w-full" onClick={handleSubmit}>
              {loading ? "Entrando..." : "Entrar"}
            </Button>
            <Link to="/esqueci-senha" className="text-sm text-muted-foreground hover:text-brand-primary">
              Esqueceu sua senha?
            </Link>
          </CardFooter>
          <CardFooter className="w-full flex justify-center">
            <p className="text-sm text-muted-foreground">
              Não tem uma conta?{" "}
              <Link to="/cadastro" className="text-brand-primary hover:underline">
                Cadastre-se
              </Link>
            </p>
          </CardFooter>
        </Card>
      </div>
    </>
  );
};

export default Login;
